module.exports = __webpack_public_path__ + "6f89519cd632f4e48baa235ef34c5f87.pdf";